module.exports = __webpack_public_path__ + "assets/73556f282e9607c70d889d1b78d5f7e1.png";